import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=157f5c70&scoped=true&"
import script from "./register-form.vue?vue&type=script&lang=js&"
export * from "./register-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f5c70",
  null
  
)

export default component.exports